<template>
  <div id="app">
    <nav class="navbar navbar-expand navbar-dark bg-dark">
      <router-link to="/reports" class="navbar-brand">Softfocus</router-link>
      <div class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link to="/reports" class="nav-link">COPs</router-link>
        </li>
        <li class="nav-item">
          <router-link to="/add" class="nav-link">Nova COP</router-link>
        </li>
      </div>
    </nav>

    <div class="container mt-3">
      <router-view />
    </div>


    <footer class="footer">
      <div class="container">
      </div>
  </footer>
    
  </div>



</template>

<script>
export default {
  name: "app"
};
</script>
